const conditions_module = require("./Conditions_module");

class Condition {
    
    constructor()
    {
        this.data_c = {};
        this.casse = false;
    }

    initialize(data, bool)
    {
        var keys = Object.keys(data);
        for (var i = 0; i < keys.length; i++)
        {
            this.data_c[keys[i]] = [];
            for (var j = 0; j < data[keys[i]].length; j++)
            {
                this.data_c[keys[i]].push(bool);
            }
        }
    }

    test(line, conditions)
    {
        var t = 0;
        for (var i = 0; i < conditions.length; i++)
        {
            if (Array.isArray(conditions[i]))
            {
                var t_a = 0;
                for (var j = 0; j < conditions[i].length; j++)
                {
                    var r = this.test(line, conditions[i][j]);
                    if (r == 0)
                        t_a++;
                }
                if (t_a == 0)
                    t++;
            }
            else
            {
                var r = conditions_module[conditions[i]["name"]](line, conditions[i], this.casse);
                if (r == false)
                    t++;
            }
        }
        if (t > 0)
            t = 1;
        return t;
    }

    condition(data, condition, casse)
    {
        this.casse = casse;

        if (condition.length == 0)
            this.initialize(data, true);
        else
        {
            this.initialize(data, false);
            var keys = Object.keys(data);
            for (var i = 0; i < keys.length; i++)
            {
                this.data_c[keys[i]] = [];
                for (var j = 0; j < data[keys[i]].length; j++)
                {
                    this.data_c[keys[i]][j] = this.test(data[keys[i]][j], condition);
                    if (this.data_c[keys[i]][j] == 0)
                        this.data_c[keys[i]][j] = true;
                    else
                        this.data_c[keys[i]][j] = false;
                }
            }
        }

        return this.data_c;
    }

}

export { Condition }